import React from 'react';
import styled from 'styled-components';
import Loader from "react-loader-spinner";
import { Input } from '../Input';

const Container = styled.div`
    display: ${props => props.inline ? 'flex' : ''};
    align-items: center;
    margin: 10px 0;
`;

const Title = styled.p`
    margin: 0 10px 0 0;
    font-weight: 600;
    color: #121180;
`;

const MapLabel = styled.label`
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    opacity: ${props => props.disabled ? 0.6 : 1};
    padding: 8px 15px;
    border: 1px solid #121180;
    border-radius: 5px;
    font-size: 14px;
    background: #fff;
    margin-right: 15px;
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    :hover{
        border: ${props => props.disabled ? '' : '2px solid #121180'};
    }
`;

const Map = ({ loading, inline, isArabic, formID, label, arabiclabel, value: orgValue, placeholder, arabicplaceholder, required, disabled, onClick, handleMapValueChange, error }) => {
    let value = orgValue ? orgValue.address : orgValue;
    value = (value && value.length > 15) ? value.slice(0, 15) + '..' : value;
    return (
        <div className={"d-flex align-items-end col-12 p-0 " + (isArabic ? 'arabic' : '')}>
            <Container inline={inline} className="col-11 p-0">
                {label && <Title className={isArabic ? 'arabic' : ''}>{isArabic ? arabiclabel : label} {required && <span style={{color: 'red', marginLeft: '2px'}}>*</span>}</Title>}
                <div className="d-flex justify-content-start">
                    <div className="d-flex align-items-center col-6 p-0">
                        <MapLabel htmlFor={label} disabled={disabled} onClick={onClick}>
                            {loading 
                                ? <Loader type="Oval" color="#2d207d" height={20} width={20} style={{marginLeft: '10px'}} /> 
                                : <img src={'/Assets/google-map.png'} alt="Google Map" style={{width: '40px', height: 'auto'}} />}
                            {/* (value ? value : ((placeholder && placeholder.length > 0) ? (isArabic ? arabicplaceholder : placeholder) : `${isArabic ? 'اختيار موقع' : 'Choose Location'}`)) */}
                        </MapLabel>
                    </div>
                    <div className="col-6 p-0">
                        <Input disabled={(value === undefined) || (value.address === '')} value={orgValue && orgValue.address}
                            placeholder="Edit the address" inline={true} onChange={handleMapValueChange} />
                    </div>
                </div>
                {error && <p className="text-danger" style={{margin: '5px 0 0 0'}}>{error}</p>}
            </Container>
        </div>
    );
};

export default Map;